<div id="brand-overlay"></div>
<div id="branded"></div>

<div class="d-flex align-items-center auth px-0">
    <div class="row w-100 mx-0">
        <div class="col-12 col-lg-10 col-xl-6 mx-auto" id="not-auth-upper">
            <div id="not-auth-modal" class="text-left py-5 px-4 px-sm-5">
                <div class="brand-logo">
                    <a routerLink="../login">
                        <img src="assets/images/logo.svg" alt="agaia logo">
                    </a>
                </div>
                <div class="heading-text">
                    <h4>{{'auth_login_title' | localise}}</h4>
                    <h6 class="font-weight-light">{{ 'auth_login_text' | localise }}</h6>
                </div>
                <form class="pt-3" [formGroup]="loginForm">
                    <div class="form-group">
                        <input type="email" name="email" class="form-control form-control-lg"
                               [placeholder]="'auth_email' | localise" formControlName="email">
                    </div>
                    <div class="form-group">
                        <input type="password" name="password" class="form-control form-control-lg"
                               [placeholder]="'auth_password' | localise" formControlName="password">
                    </div>
                    <div class="mt-3">
                        <button class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                                (click)="onLogin()" [disabled]="!loginForm.valid">{{'auth_sign_in' | localise}}</button>
                    </div>
                    <div class="my-2 d-flex justify-content-between align-items-center">
                        <div class="form-check">
                            <label class="form-check-label text-muted">
                                <input type="checkbox" class="form-check-input" (input)="persistLogin = !persistLogin">
                                <i class="input-helper"></i>
                                {{'auth_keep_me_signed_in' | localise}}
                            </label>
                        </div>
                        <a [routerLink]="['../forgot-password']"
                           class="auth-link text-black">{{'auth_forgot_password' | localise}}</a>
                    </div>
                    <div class="mb-2" style="padding-top: 15px;">
                        <button type="button" class="btn btn-block btn-success btn-sign-up auth-form-btn"
                                routerLink="../register">
                            <i class="ti-user mr-2"></i>{{'create' | localise}}
                        </button>

<!--                        <button type="button" class="btn btn-block btn-facebook auth-form-btn"-->
<!--                                (click)="onFacebookLogin()">-->
<!--                            <i class="ti-facebook mr-2"></i>{{'auth_sign_in_facebook' | localise}}-->
<!--                        </button>-->
                    </div>
                </form>

                <div style="text-align: center;cursor: pointer;margin-top: 20px;">
                    <a class="nav-link dropdown-toggle" [app-popup]="{
              templateRef: languagesPopupTemplate,
              position: 'top',
              arrowPosition: ['top', 'center'],
              paddingless: true,
              closeUponSelection: true
            }">
                        <i class="ti-world mx-0"></i>
                        {{ 'change_language' | localise }}
                    </a>
                </div>

                <ng-template #languagesPopupTemplate>
                    <a class="dropdown-item preview-item" *ngFor="let language of languages"
                       (click)="onLanguageSelected(language)">
                        <div class="preview-thumbnail">
                            <div class="responsive-flex-wrapper">
                                <i [ngClass]="'m-0 flag-icon flag-icon-' + flagIcon(language)"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">{{ language | localise }}</div>
                    </a>
                </ng-template>
            </div>

            <div id="stores">
                <a href="https://apps.apple.com/app/agaia-life/id1589104436" target="_blank">
                    <img src="assets/images/apps/ios.svg" height="42" style="margin-right: 8px;"/>
                </a>

                <a href="https://play.google.com/store/apps/details?id=life.agaia.app" target="_blank">
                    <img src="assets/images/apps/play-store-2.png" height="42"/>
                </a>

            </div>
        </div>
    </div>
</div>  
